import Swiper, { Navigation, EffectFade, Autoplay} from 'swiper'

const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    Swiper.use([ Navigation, EffectFade, Autoplay ]);
    
    let config = {
        effect: 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        // Navigation (arrow)
        navigation: {
            nextEl: `.swiper-button-next`,
            prevEl: `.swiper-button-prev`,
        }
    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
    }
}


// Slider posts
const postsSlideshow = document.querySelector('.posts .swiper-container') !== null;
        
if (postsSlideshow) {
    let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

    Swiper.use([ Navigation ]);

    let postsConfig = {
        grabCursor : 'true',
        speed: 700,
        loop : false,
        slidesPerView: 2,
        spaceBetween: 30,

        fadeEffect: {
            crossFade: true
        },
    
        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true, 
        },

        navigation: {
            nextEl: `.posts .swiper-button-next`,
            prevEl: `.posts .swiper-button-prev`,
        },

        breakpoints: {

            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },

            641: {
                slidesPerView: 2,
                spaceBetween: 20,
            },

            1201: {
                slidesPerView: 2,
                spaceBetween: 30,
            }
        }
    }
    
    if(postsSlides > 1){
        let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
    }

    const postsNavigation = document.querySelector('.posts__navigation');

    // Fonction pour vérifier la taille de l'écran et le nombre de postsSlides
    function checkScreenSize() {
        const screenSize = window.innerWidth;
        const postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

        if (screenSize > 640 && postsSlides <= 2) {
            postsNavigation.classList.add('disable');
        } else if (screenSize <= 640 && postsSlides <= 1) {
            postsNavigation.classList.add('disable');
        } else {
            postsNavigation.classList.remove('disable');
        }
    }

    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);
}

// Slider events
const eventsSlideshow = document.querySelector('.events .swiper-container') !== null;
        
if (eventsSlideshow) {
    let eventsSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;

    Swiper.use([ Navigation ]);

    let eventsConfig = {
        grabCursor : 'true',
        speed: 700,
        loop : false,
        slidesPerView: 2,
        spaceBetween: 30,

        fadeEffect: {
            crossFade: true
        },
    
        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true, 
        },

        navigation: {
            nextEl: `.events .swiper-button-next`,
            prevEl: `.events .swiper-button-prev`,
        },

        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },

            641: {
                slidesPerView: 2,
                spaceBetween: 20,
            },

            1201: {
                slidesPerView: 2,
                spaceBetween: 30,
            }
        }
    }
    
    if(eventsSlides > 1){
        let swiperEvents = new Swiper('.events .swiper-container', eventsConfig);
    }

    const postsNavigationEvents = document.querySelector('.events__navigation');

    // Fonction pour vérifier la taille de l'écran et le nombre de postsSlides
    function checkScreenSizeEvents() {
        const screenSizeEvents = window.innerWidth;
        const eventsSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;

        if (screenSizeEvents > 1200 && eventsSlides <= 3) {
            postsNavigationEvents.classList.add('disable');
        } else if (screenSizeEvents >= 960 && eventsSlides <= 2) {
            postsNavigationEvents.classList.add('disable');
        } else if (screenSizeEvents <= 640 && eventsSlides <= 1) {
            postsNavigationEvents.classList.add('disable');
        } else {
            postsNavigationEvents.classList.remove('disable');
        }
    }

    checkScreenSizeEvents();

    window.addEventListener('resize', checkScreenSizeEvents);
}